export const WORKSPACE_TAB_TITLES: Record<string, string> = {
  overview: "Overview",
  "client-overview": "Overview",
  files: "Context & Files",
  chat: "Chat",
  diagnostics: "NH Diagnostic IQ",
  "nh-diagnostic-iq": "NH Diagnostic IQ",
  "ai-analytics": "AI Analytics",
  claude: "Claude",
  "value-story": "Value Story",
  retrospective: "Retrospective",
  "quality-review": "Quality Review",
  "project-reviews": "Project Reviews",
  deliverables: "Deliverables",
  "client-deliverables": "Deliverables",
  "client-invitations": "Invitations",
  capabilities: "Capabilities",
  people: "People",
  value: "Value",
  plan: "Engagement Plan",
};
